import { render, staticRenderFns } from "./FieldRecordSystemModuleRoot.vue?vue&type=template&id=cad2332a&scoped=true&lang=html&"
import script from "./FieldRecordSystemModuleRoot.vue?vue&type=script&lang=js&"
export * from "./FieldRecordSystemModuleRoot.vue?vue&type=script&lang=js&"
import style0 from "./FieldRecordSystemModuleRoot.vue?vue&type=style&index=0&id=cad2332a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad2332a",
  null
  
)

export default component.exports